import { handleError } from './errors.js';

export const copyToClipboard = () => {
    const hideAllAlerts = () => {
        document.querySelectorAll('[vdx-copy-alert]').forEach((alert) => {
            alert.style.display = 'none';
        });
    };

    const showAlert = (alertElement, defaultAlert) => {
        if (alertElement) {
            alertElement.style.display = 'block';
        } else if (defaultAlert) {
            defaultAlert.style.display = 'block';
        }
        setTimeout(() => {
            if (alertElement) alertElement.style.display = 'none';
            if (defaultAlert) defaultAlert.style.display = 'none';
        }, 2000);
    };

    hideAllAlerts();

    document.querySelectorAll('[vdx-copy-button]').forEach((button) => {
        const targetId = button.getAttribute('vdx-copy-button');
        const targetElement = document.querySelector(`[vdx-copy-this="${targetId}"]`);
        const alertElement = targetId ? document.querySelector(`[vdx-copy-alert="${targetId}"]`) : null;
        const defaultAlert = document.querySelector('[vdx-copy-alert=""]');

        if (targetElement) {
            button.addEventListener('click', (event) => {
                let textToCopy;
                if (targetElement.hasAttribute('href')) {
                    const href = targetElement.getAttribute('href');
                    if (href.startsWith('mailto:')) {
                        textToCopy = href.replace('mailto:', '');
                        event.preventDefault();
                    } else if (href.startsWith('tel:')) {
                        textToCopy = href.replace('tel:', '');
                        event.preventDefault();
                    } else if (href === '#') {
                        textToCopy = window.location.href.split('#')[0];
                        event.preventDefault();
                    } else {
                        textToCopy = new URL(href, window.location.origin).href;
                    }
                } else {
                    textToCopy = targetElement.textContent || targetElement.href;
                }
                navigator.clipboard
                    .writeText(textToCopy)
                    .then(() => {
                        showAlert(alertElement, defaultAlert);
                    })
                    .catch((err) => {
                        handleError('Clipboard write failed (permission or unsupported). Check [vdx-copy-button] and [vdx-copy-this] target.', {
                            module: 'copyclip',
                            element: button,
                            showOnElement: true,
                            error: err,
                        });
                    });
            });
        } else {
            const msg = targetId
                ? `vdx-copy-button value "${targetId}" has no matching [vdx-copy-this="${targetId}"]. Add an element with vdx-copy-this="${targetId}".`
                : 'vdx-copy-button attribute is missing or empty. Set vdx-copy-button to the id of the element to copy (with vdx-copy-this).';
            handleError(msg, { module: 'copyclip', element: button, showOnElement: true });
        }
    });

    document.querySelectorAll('[vdx-copy-this]').forEach((targetElement) => {
        const targetId = targetElement.getAttribute('vdx-copy-this');
        if (!document.querySelector(`[vdx-copy-button="${targetId}"]`)) {
            const msg = targetId
                ? `vdx-copy-this value "${targetId}" has no matching [vdx-copy-button="${targetId}"]. Add a button with vdx-copy-button="${targetId}".`
                : 'vdx-copy-this attribute is missing or empty. Set vdx-copy-this to match a vdx-copy-button value.';
            handleError(msg, { module: 'copyclip', element: targetElement, showOnElement: true });
        }
    });
};
